import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";

export default {
  name: "TocExcel",
  components: { customModal },
  emits: ["closeModal", "importSuccess"],
  data() {
    return {
      selectedFile: null,
      isLoading: false,
      fileError: false,
      isDragging: false,
      baseUrl: process.env.VUE_APP_Service_URL,
    };
  },
  methods: {
    handleDrop(event) {
      this.isDragging = false;
      this.fileError = false;
      const droppedFiles = event.dataTransfer.files;
      if (droppedFiles.length > 0) {
        const file = droppedFiles[0];
        const validExtensions = [".xlsx", ".xls"];
        const fileExtension = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        if (validExtensions.includes(fileExtension)) {
          this.selectedFile = file;
        } else {
          this.fileError = true;
          this.selectedFile = null;
        }
      }
    },
    handleFileChange(event) {
      this.fileError = false;
      const file = event.target.files[0];
      if (file) {
        const validExtensions = [".xlsx", ".xls"];
        const fileExtension = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        if (validExtensions.includes(fileExtension)) {
          this.selectedFile = file;
        } else {
          this.fileError = true;
          this.selectedFile = null;
        }
      } else {
        this.selectedFile = null;
      }
    },
    async uploadExcel() {
      if (!this.selectedFile) {
        this.fileError = true;
        return;
      }
      this.isLoading = true;
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;
      const formData = new FormData();
      formData.append("file", this.selectedFile);

      try {
        const res = await axios.post(
          `${this.baseUrl}/stats-python/toc/uploadtocexcel?study_id=${studyId}`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        alert("Excel imported successfully");
        this.$emit("importSuccess");
        this.$emit("closeModal");
      } catch (err) {
        const msg =
          err.response?.data?.details ||
          err.response?.data?.message ||
          "Import failed.";
        alert(msg);
      } finally {
        this.isLoading = false;
      }
    },
  },
};